<template>
    <div>
        <h3>เพิ่ม/แก้ไข ประเภทชีท</h3>
        <br>
        <div class="row form-group" v-if="form">
            <div class="col-4 text-right">ชื่อประเภทชื่อ</div>
            <div class="col-6">
                <input type="text" class="form-control" v-model="form.name"/>
            </div>
        </div>
        <div class="col text-center">
            <button @click="commitData"
                type="button"
                class="btn btn-success">
                <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
            <button type="button" @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props : {form : null},
        name: "sheet-type-information-modal",
        methods:{
            commitData(){
                this.$emit("submit",this.form);
            },
            cancelData(){
                this.$emit("submit",false);
            }

        }
    }
</script>

<style scoped>

</style>
